document.addEventListener('DOMContentLoaded', () => {
  const calculator = document.getElementById('custom-calculator-wrapper');
  if (!calculator) return;

  // --- Configuration (All your pricing rules) ---
  // Centralized pricing - fetched from API
  let PRICE_PER_SQ_METER = { '3mm': 899, '4mm': 799, '5mm': 899 }; // Fallback values
  let pricingLastFetched = 0;
  const PRICING_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  // Fetch current pricing from centralized API
  async function fetchCurrentPricing() {
    try {
      // Check cache first
      const now = Date.now();
      if ((now - pricingLastFetched) < PRICING_CACHE_DURATION) {
        debugLog('Using cached pricing');
        return PRICE_PER_SQ_METER;
      }

      debugLog('Fetching fresh pricing from API...');
      
      const response = await fetch('https://flourishing-cactus-81c4c1.netlify.app/.netlify/functions/get-pricing');
      
      if (!response.ok) {
        throw new Error(`Pricing API error: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Update pricing cache
      PRICE_PER_SQ_METER = {
        '3mm': data.pricing['3mm'].current,
        '4mm': data.pricing['4mm'].current,
        '5mm': data.pricing['5mm'].current
      };
      pricingLastFetched = now;
      
      debugLog('Fresh pricing loaded:', PRICE_PER_SQ_METER);
      return PRICE_PER_SQ_METER;
      
    } catch (error) {
      debugLog('Failed to fetch pricing, using fallback:', error);
      
      // Return current fallback pricing
      return PRICE_PER_SQ_METER;
    }
  }
  const SHAPE_SURCHARGES = { 'arched': 10.00, 'half-arch': 10.00, 'both-top-corners-cut': 7.04, 'single-corner-cut': 7.04, 'all-corners-cut': 7.04, 'sloped-top': 7.04, 'trapezium': 7.04, 'square-rectangular': 0, 'circular': 0 };
  const MINIMUM_PRICE = 13.97;
  const PRICE_UNIT_VARIANT_ID = '55795499139459'; // Your correct Variant ID
  
  // Shipping surcharges based on size
  const SHIPPING_SURCHARGE = {
    MEDIUM: 11.01,  // For sizes 600-999mm
    LARGE: 43.01    // For sizes 1000mm+
  };
  
  // Debug helper function
  const DEBUG_MODE = localStorage.getItem('calculatorDebug') === 'true';
  const debugLog = (...args) => {
    if (DEBUG_MODE) console.log(...args);
  };

  // --- Get all calculator elements ---
  const allInputs = calculator.querySelectorAll('select, input[type="number"]');
  const unitSelect = calculator.querySelector('#calc-units');
  const shapeSelect = calculator.querySelector('#calc-shape');
  const thicknessSelect = calculator.querySelector('#calc-thickness');
  const widthInput = calculator.querySelector('#calc-width');
  const heightInput = calculator.querySelector('#calc-height');
  const inputC = calculator.querySelector('#calc-c');
  const inputD = calculator.querySelector('#calc-d');
  const diameterInput = calculator.querySelector('#calc-diameter');
  const ropeSelect = calculator.querySelector('#calc-rope');
  const tapeSelect = calculator.querySelector('#calc-tape');
  const quantityInput = calculator.querySelector('#calc-quantity');
  const priceDisplay = calculator.querySelector('#custom-price-display');
  const hiddenPriceInput = calculator.querySelector('#custom-price-property');
  const drawingUploadNote = calculator.querySelector('[data-input-for="drawing"]');
  
  // File upload elements
  const fileInput = calculator.querySelector('#drawing-upload');
  const uploadButton = calculator.querySelector('#upload-button');
  const uploadText = calculator.querySelector('#upload-text');
  const uploadStatus = calculator.querySelector('#upload-status');
  const uploadedFileInfo = calculator.querySelector('#uploaded-file-info');
  const fileName = calculator.querySelector('#file-name');
  const removeFileButton = calculator.querySelector('#remove-file');
  const uploadedFileUrl = calculator.querySelector('#uploaded-file-url');
  const dimensionRows = { 'a-b': calculator.querySelector('[data-dimension-row="a-b"]'), 'c-d': calculator.querySelector('[data-dimension-row="c-d"]'), 'diameter': calculator.querySelector('[data-dimension-row="diameter"]') };
  const dimensionLabels = { 'width': calculator.querySelector('#label-width'), 'height': calculator.querySelector('#label-height'), 'c': calculator.querySelector('#label-c'), 'd': calculator.querySelector('#label-d'), 'diameter': calculator.querySelector('#label-diameter') };
  const shapeConfig = { 
    'square-rectangular': { 
      rows: ['a-b'], 
      labels: { width: 'Width', height: 'Height' },
      propertyLabels: { width: 'Width', height: 'Height' },
      image: 'shape-square-rectangular.svg',
      caption: 'Square/Rectangular Glass',
      dimensionLabels: { width: 'A', height: 'B' }
    }, 
    'arched': { 
      rows: ['a-b'], 
      labels: { width: 'Width', height: 'Height to Top of Arch' },
      propertyLabels: { width: 'Width', height: 'Height to Top of Arch' },
      image: 'shape-arched.svg',
      caption: 'Arched Glass',
      dimensionLabels: { width: 'A', height: 'B' }
    }, 
    'half-arch': { 
      rows: ['a-b'], 
      labels: { width: 'Width', height: 'Height to Top of Arch' },
      propertyLabels: { width: 'Width', height: 'Height to Top of Arch' },
      image: 'shape-half-arch.svg',
      caption: 'Half Arch Glass',
      dimensionLabels: { width: 'A', height: 'B' }
    }, 
    'both-top-corners-cut': { 
      rows: ['a-b', 'c-d'], 
      labels: { width: 'Overall Width (A)', height: 'Overall Height (B)', c: 'Height to Cut-off (C)', d: 'Top Flat Width (D)' },
      propertyLabels: { width: 'Overall Width', height: 'Overall Height', c: 'Height to Cut-off', d: 'Top Flat Width' },
      image: 'shape-both-corners-cut.svg',
      caption: 'Both Top Corners Cut',
      dimensionLabels: { width: 'A', height: 'B', c: 'C', d: 'D' }
    }, 
    'single-corner-cut': { 
      rows: ['a-b', 'c-d'], 
      labels: { width: 'Overall Width (A)', height: 'Overall Height (B)', c: 'Cut Off Height (C)', d: 'Cut Off Width (D)' },
      propertyLabels: { width: 'Overall Width', height: 'Overall Height', c: 'Cut Off Height', d: 'Cut Off Width' },
      image: 'shape-single-corner-cut.svg',
      caption: 'Single Corner Cut',
      dimensionLabels: { width: 'A', height: 'B', c: 'C', d: 'D' }
    },
    'all-corners-cut': { 
      rows: ['a-b', 'c-d'], 
      labels: { width: 'Overall Width (A)', height: 'Overall Height (B)', c: 'Corner Cut Vertical (C)', d: 'Corner Cut Horizontal (D)' },
      propertyLabels: { width: 'Overall Width', height: 'Overall Height', c: 'Corner Cut Vertical', d: 'Corner Cut Horizontal' },
      image: 'shape-all-corners-cut.svg',
      caption: 'All Corners Cut',
      dimensionLabels: { width: 'A', height: 'B', c: 'C', d: 'D' },
      customLayout: true // Flag to indicate special layout
    },
    'sloped-top': { 
      rows: ['a-b', 'c-d'], 
      labels: { width: 'Bottom Width (A)', height: 'Left Height (B)', c: 'Right Height (C)', d: 'Unused' },
      propertyLabels: { width: 'Bottom Width', height: 'Left Height', c: 'Right Height', d: 'Unused' },
      image: 'shape-sloped-top.svg',
      caption: 'Sloped Top Glass',
      dimensionLabels: { width: 'A', height: 'B', c: 'C', d: 'D' }
    },
    'circular': { 
      rows: ['diameter'], 
      labels: { diameter: 'Diameter' },
      propertyLabels: { diameter: 'Diameter' },
      image: 'shape-circular.svg',
      caption: 'Circular Glass',
      dimensionLabels: { diameter: 'D' }
    },
    'trapezium': { 
      rows: ['a-b', 'c-d'], 
      labels: { width: 'Bottom Width', height: 'Height', c: 'Top Width', d: 'Unused' },
      propertyLabels: { width: 'Bottom Width', height: 'Height', c: 'Top Width', d: 'Unused' },
      image: 'shape-trapezium.svg',
      caption: 'Trapezium Glass',
      dimensionLabels: { width: 'A', height: 'B', c: 'C', d: 'D' }
    }
  };
  
  let itemPrice = 0; // To store the price of a single item

  // --- Duplicate function removed - using the first instance above ---

  // --- Shape Preview Update Function ---
  function updateShapePreview() {
    console.log('updateShapePreview called'); // Debug log
    const selectedShape = shapeSelect.value;
    const currentConfig = shapeConfig[selectedShape];
    
    console.log('Selected shape:', selectedShape); // Debug log
    console.log('Current config:', currentConfig); // Debug log
    
    if (currentConfig) {
      // Update image
      const previewImage = document.getElementById('shape-preview-image');
      const previewCaption = document.getElementById('shape-preview-caption');
      
      console.log('Preview image element:', previewImage); // Debug log
      console.log('Preview caption element:', previewCaption); // Debug log
      
      if (previewImage) {
        // Use the same format as the initial image src
        const baseUrl = previewImage.src.split('/').slice(0, -1).join('/');
        const newImageUrl = `${baseUrl}/${currentConfig.image}`;
        
        console.log('Base URL:', baseUrl); // Debug log
        console.log('New image URL:', newImageUrl); // Debug log
        previewImage.src = newImageUrl;
        previewImage.alt = currentConfig.caption;
        
        // Add error handling
        previewImage.onerror = function() {
          console.log('Failed to load image:', currentConfig.image);
          console.log('Tried URL:', this.src);
          this.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjE1MCIgeT0iMTAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM2NjYiPkltYWdlIE5vdCBGb3VuZDwvdGV4dD48L3N2Zz4=';
        };
        
        previewImage.onload = function() {
          console.log('Image loaded successfully:', currentConfig.image);
        };
      }
      
      if (previewCaption) {
        previewCaption.textContent = currentConfig.caption;
        console.log('Caption updated to:', currentConfig.caption); // Debug log
      }
      
      // Update dimension labels on image (if you want to add them later)
      const labelsContainer = document.getElementById('shape-preview-labels');
      if (labelsContainer) {
        labelsContainer.innerHTML = ''; // Clear existing labels
        // You can add positioned labels here if needed
      }
    } else {
      console.log('No config found for shape:', selectedShape); // Debug log
    }
  }

  // --- Master Update Function ---
  async function updateCalculator() {
    debugLog('=== UPDATE CALCULATOR CALLED ===');
    
    // Fetch current pricing before calculations
    await fetchCurrentPricing();
    
    // 1. Update UI
    const selectedShape = shapeSelect.value;
    const currentConfig = shapeConfig[selectedShape];
    const unitText = `(${unitSelect.value})`;
    const selectedUnit = unitSelect.value;
    
    // Handle inches unit - convert to nearest 1/8th inch
    if (selectedUnit === 'in') {
      const inputFields = [widthInput, heightInput, inputC, inputD, diameterInput];
      inputFields.forEach(input => {
        if (input && input.value && input.value !== '0') {
          // Convert to nearest 1/8th inch for display
          const value = parseFloat(input.value);
          // Round to nearest 1/8th (0.125)
          const roundedValue = Math.round(value * 8) / 8;
          
          // Only update if different to avoid cursor jumping
          if (Math.abs(roundedValue - value) > 0.001) {
            input.value = roundedValue.toFixed(3).replace(/\.?0+$/, '');
          }
        }
      });
    }
    
    debugLog('Selected shape in updateCalculator:', selectedShape);
    debugLog('Current config in updateCalculator:', currentConfig);
    
    // Hide all dimension rows first
    Object.values(dimensionRows).forEach(row => {
      if (row) {
        row.style.display = 'none';
        debugLog('Hiding row:', row);
      }
    });
    
    if (currentConfig) {
      // Show required rows for this shape
      currentConfig.rows.forEach(rowKey => { 
        if (dimensionRows[rowKey]) { 
          dimensionRows[rowKey].style.display = (rowKey === 'c-d' || rowKey === 'a-b') ? 'flex' : 'block';
          debugLog('Showing row:', rowKey, dimensionRows[rowKey]);
        } 
      });
      
      // Update labels
      Object.entries(currentConfig.labels).forEach(([labelKey, labelText]) => { 
        if (dimensionLabels[labelKey]) { 
          const fieldWrapper = dimensionLabels[labelKey].parentElement; 
          if (labelText && labelText !== 'Unused') { 
            dimensionLabels[labelKey].innerHTML = `${labelText} <span class="calc-unit-label">${unitText}</span>`; 
            fieldWrapper.style.display = 'block';
            debugLog('Updated label:', labelKey, 'to:', labelText);
          } else { 
            fieldWrapper.style.display = 'none'; 
            debugLog('Hiding unused field:', labelKey);
          } 
        } 
      });
      
      // Special layout for all-corners-cut: rearrange field order
      if (selectedShape === 'all-corners-cut' && currentConfig.customLayout) {
        const dimensionContainer = calculator.querySelector('#calculator-dimensions-container');
        const widthField = dimensionLabels['width']?.parentElement;
        const heightField = dimensionLabels['height']?.parentElement;
        const cField = dimensionLabels['c']?.parentElement;
        const dField = dimensionLabels['d']?.parentElement;
        
        if (dimensionContainer && widthField && heightField && cField && dField) {
          // Create temporary container to reorganize
          const tempDiv = document.createElement('div');
          tempDiv.className = 'custom-calculator__reorganized';
          
          // Clone fields to avoid moving issues
          const widthClone = widthField.cloneNode(true);
          const dClone = dField.cloneNode(true);
          const heightClone = heightField.cloneNode(true);
          const cClone = cField.cloneNode(true);
          
          // Clear container
          const abRow = dimensionRows['a-b'];
          const cdRow = dimensionRows['c-d'];
          
          if (abRow && cdRow) {
            // Clear existing content
            abRow.innerHTML = '';
            cdRow.innerHTML = '';
            
            // Add in desired order: Width, Corner Cut Horizontal, Height, Corner Cut Vertical
            abRow.appendChild(widthClone);
            abRow.appendChild(dClone); // Corner Cut Horizontal under Width
            
            cdRow.appendChild(heightClone);
            cdRow.appendChild(cClone); // Corner Cut Vertical under Height
            
            // Reattach event listeners to cloned elements
            const newInputs = [
              widthClone.querySelector('input'),
              dClone.querySelector('input'),
              heightClone.querySelector('input'),
              cClone.querySelector('input')
            ].filter(Boolean);
            
            newInputs.forEach(input => {
              input.addEventListener('input', updateCalculator);
              input.addEventListener('change', updateCalculator);
            });
            
            debugLog('Reorganized all-corners-cut layout');
          }
        }
      }
    }
    
    // Only show drawing upload for complex shapes
    drawingUploadNote.style.display = (selectedShape === 'square-rectangular' || selectedShape === 'circular') ? 'none' : 'block';
    
    // Show/hide template checkbox based on shape and file upload status
    const templateCheckboxContainer = document.querySelector('.custom-calculator__checkbox-label');
    const fileUploadedInput = document.getElementById('uploaded-file-url');
    const fileUploaded = fileUploadedInput && fileUploadedInput.value;
    
    if (templateCheckboxContainer) {
      // Only show for arched and half-arch, and only if no file is uploaded
      const showTemplateCheckbox = (selectedShape === 'arched' || selectedShape === 'half-arch') && !fileUploaded;
      templateCheckboxContainer.style.display = showTemplateCheckbox ? 'flex' : 'none';
    }
    
    // 2. Update shape preview
    updateShapePreview();

    // 3. Calculate Price
    const units = unitSelect.value;
    const thickness = thicknessSelect.value;
    const quantity = parseInt(quantityInput.value) || 1;
    let width = parseFloat(widthInput.value) || 0;
    let height = parseFloat(heightInput.value) || 0;
    const diameter = parseFloat(diameterInput.value) || 0;
    let areaM2 = 0;
    if (selectedShape === 'circular') {
        // Calculate based on unit of measurement
        let squareFactor;
        let diameterValue = diameter;
        
        if (units === 'mm') {
            // For mm: (Diameter (mm) * Diameter (mm) / 1000000 * (glass thickness square meter rate + 1127))
            squareFactor = 1000000;
        } else if (units === 'cm') {
            // For cm: (Diameter (cm) * Diameter (cm) / 10000 * (glass thickness square meter rate + 1127))
            squareFactor = 10000;
        } else { // inches
            // Convert inches to mm first
            diameterValue = diameter * 25.4; // inches to mm
            squareFactor = 1000000; // then use mm formula
        }
        
        // Apply the formula with appropriate square factor
        const circleRate = PRICE_PER_SQ_METER[thickness] + 1127;
        total = (diameterValue * diameterValue / squareFactor) * circleRate;
        
        // Calculate area for display purposes
        if (units === 'mm') {
            areaM2 = Math.PI * Math.pow(diameterValue / 2000, 2); // mm to m (radius)
        } else if (units === 'cm') {
            areaM2 = Math.PI * Math.pow(diameterValue / 200, 2); // cm to m (radius)
        } else { // inches
            areaM2 = Math.PI * Math.pow(diameterValue / 2000, 2); // already converted to mm above
        }
    } else {
        // Regular rectangular area calculation
        const w_m = width / (units === 'mm' ? 1000 : (units === 'cm' ? 100 : 39.37));
        const h_m = height / (units === 'mm' ? 1000 : (units === 'cm' ? 100 : 39.37));
        areaM2 = w_m * h_m;
        
        // Calculate price based on area for non-circular shapes
        total = areaM2 * PRICE_PER_SQ_METER[thickness];
    }
    // Store glass price before accessories
    let glassPrice = total;
    
    // Apply shape surcharges for non-circular shapes
    if (selectedShape !== 'circular') {
        glassPrice += SHAPE_SURCHARGES[selectedShape] || 0;
    }
    
    // Apply minimum price to glass only (before accessories)
    if (glassPrice > 0 && glassPrice < MINIMUM_PRICE) {
      glassPrice = MINIMUM_PRICE;
    }
    
    // Calculate shipping surcharge based on size
    let shippingSurcharge = 0;
    
    // Determine the largest dimension in mm for shipping calculation
    let largestDimension = 0;
    
    if (selectedShape === 'circular') {
        // For circular, convert diameter to mm
        if (units === 'mm') {
            largestDimension = diameter;
        } else if (units === 'cm') {
            largestDimension = diameter * 10; // cm to mm
        } else { // inches
            largestDimension = diameter * 25.4; // inches to mm
        }
    } else {
        // For other shapes, find the largest dimension between width and height
        let widthInMm, heightInMm;
        
        if (units === 'mm') {
            widthInMm = width;
            heightInMm = height;
        } else if (units === 'cm') {
            widthInMm = width * 10; // cm to mm
            heightInMm = height * 10; // cm to mm
        } else { // inches
            widthInMm = width * 25.4; // inches to mm
            heightInMm = height * 25.4; // inches to mm
        }
        
        largestDimension = Math.max(widthInMm, heightInMm);
    }
    
    // Apply shipping surcharge based on largest dimension
    if (largestDimension >= 1000) {
        shippingSurcharge = SHIPPING_SURCHARGE.LARGE;
    } else if (largestDimension >= 600) {
        shippingSurcharge = SHIPPING_SURCHARGE.MEDIUM;
    }
    
    // Add shipping surcharge to glass price
    glassPrice += shippingSurcharge;
    
    // Add accessories
    const ropePrice = parseFloat(ropeSelect.options[ropeSelect.selectedIndex].dataset.price) || 0;
    const tapePrice = parseFloat(tapeSelect.options[tapeSelect.selectedIndex].dataset.price) || 0;
    
    // Calculate total price (glass + accessories)
    total = glassPrice + ropePrice + tapePrice;
    
    itemPrice = total; // Store the single item price
    const finalDisplayPrice = itemPrice * quantity;
    
    // Display price without showing shipping surcharge info
    let priceText = `£${areaM2 > 0 ? finalDisplayPrice.toFixed(2) : '0.00'}`;
    
    // No longer showing shipping surcharge info to customers
    priceDisplay.textContent = priceText;
    hiddenPriceInput.value = `£${itemPrice.toFixed(2)}`;
  }

  // --- Add to Cart Logic (SIMPLE VARIANT POOL) ---
  const customAddToCartButton = calculator.querySelector('#custom-add-to-cart-button');
  const addToCartText = calculator.querySelector('#custom-add-to-cart-text');
  
  // Initialize simple variant pool (preferred) with fallbacks
  const simplePool = window.SimpleVariantPool ? new window.SimpleVariantPool() : null;
  const draftOrderHandler = window.DraftOrderHandler ? new window.DraftOrderHandler() : null;
  
  // Pool variants are ready immediately - no loading needed
  
  customAddToCartButton.addEventListener('click', async (event) => {
    // Prevent default action immediately
    event.preventDefault();
    event.stopPropagation();
    
    const userQuantity = parseInt(quantityInput.value) || 1;
    const selectedShape = shapeSelect.value;
    const currentConfig = shapeConfig[selectedShape];
    
    // CRITICAL: Validate dimensions before allowing order
    const width = parseFloat(widthInput.value) || 0;
    const height = parseFloat(heightInput.value) || 0;
    const diameter = parseFloat(diameterInput.value) || 0;
    
    console.log('Validation check - Shape:', selectedShape, 'Width:', width, 'Height:', height, 'Diameter:', diameter);
    
    // Check for zero dimensions - STRICT validation
    if (selectedShape === 'circular') {
      if (!diameter || diameter <= 0) {
        alert('Please enter a valid diameter before adding to cart.');
        console.log('Validation failed: Invalid diameter');
        return false; // Explicit return false
      }
    } else {
      if (!width || width <= 0 || !height || height <= 0) {
        alert('Please enter valid width and height dimensions before adding to cart.');
        console.log('Validation failed: Invalid width or height');
        return false; // Explicit return false
      }
    }
    
    console.log('Validation passed, proceeding with add to cart');
    
    // Additional validation for minimum sizes (prevent unrealistic orders)
    if (selectedShape === 'circular') {
      if (diameter < 10) {
        alert('Minimum diameter is 10mm. Please enter a larger size.');
        return;
      }
    } else {
      if (width < 10 || height < 10) {
        alert('Minimum dimensions are 10mm x 10mm. Please enter larger sizes.');
        return;
      }
    }
    
    // Prepare properties object - Clean customer-friendly format
    let properties = {};
    
    // Convert shape to customer-friendly name
    const shapeDisplayNames = {
      'square-rectangular': 'Rectangular',
      'arched': 'Arched',
      'half-arch': 'Half Arch',
      'both-top-corners-cut': 'Corner Cut',
      'single-corner-cut': 'Single Corner Cut',
      'sloped-top': 'Sloped Top',
      'circular': 'Circular'
    };
    
    // Only include customer-visible properties (no underscores or internal data)
    properties['Glass Type'] = `${shapeDisplayNames[shapeSelect.value] || 'Custom'} ${thicknessSelect.value} Glass`;
    
    // Only include relevant dimension properties based on shape
    if (currentConfig) {
      if (currentConfig.rows.includes('a-b')) {
        const widthValue = parseFloat(widthInput.value) || 0;
        const heightValue = parseFloat(heightInput.value) || 0;
        if (widthValue > 0) {
          properties[currentConfig.propertyLabels.width || 'Width'] = widthValue + ' ' + unitSelect.value;
        }
        if (heightValue > 0) {
          properties[currentConfig.propertyLabels.height || 'Height'] = heightValue + ' ' + unitSelect.value;
        }
      }
      
      if (currentConfig.rows.includes('c-d')) {
        const cValue = parseFloat(inputC.value) || 0;
        const dValue = parseFloat(inputD.value) || 0;
        if (cValue > 0) {
          properties[currentConfig.propertyLabels.c || 'Input C'] = cValue + ' ' + unitSelect.value;
        }
        if (dValue > 0) {
          properties[currentConfig.propertyLabels.d || 'Input D'] = dValue + ' ' + unitSelect.value;
        }
      }
      
      if (currentConfig.rows.includes('diameter')) {
        const diameterValue = parseFloat(diameterInput.value) || 0;
        if (diameterValue > 0) {
          properties[currentConfig.propertyLabels.diameter || 'Diameter'] = diameterValue + ' ' + unitSelect.value;
        }
      }
    }
    
    // Include add-ons only if selected (customer-friendly names)
    if (ropeSelect.value !== 'none') {
      properties['Door Rope Kit'] = ropeSelect.options[ropeSelect.selectedIndex].text;
    }
    if (tapeSelect.value !== 'none') {
      properties['Glass Tape'] = tapeSelect.options[tapeSelect.selectedIndex].text;
    }
    
    // Include template checkbox if checked
    const templateCheckbox = calculator.querySelector('input[name="properties[Will Send Template]"]:checked');
    if (templateCheckbox) {
      properties['Template Required'] = 'Yes';
    }
    
    // Include uploaded file URL if present
    if (uploadedFileUrl && uploadedFileUrl.value) {
      properties['Drawing Uploaded'] = 'Yes';
      properties['Drawing URL'] = uploadedFileUrl.value;
    }
    
    // Internal properties for system use (will be filtered out in cart)
    properties['_Quantity'] = userQuantity.toString();
    properties['_Internal_Shape'] = shapeSelect.value;
    properties['_Internal_Units'] = unitSelect.value;

    // Define fallback function for original cart method
    const fallbackToOriginalCart = () => {
      const quantityForCart = Math.round(itemPrice * 100) * userQuantity;
      
      // First check if an identical item already exists in the cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log("Checking for identical items in cart");
          
          // Create a property key for matching (excluding internal properties)
          const propertyKeys = Object.keys(properties).filter(key => !key.startsWith('_'));
          const propertyKey = propertyKeys.map(key => `${key}:${properties[key]}`).sort().join('|');
          
          console.log("New item property key:", propertyKey);
          
          // Look for an identical item
          let identicalItem = null;
          let identicalItemIndex = -1;
          
          cart.items.forEach((item, index) => {
            if (item.variant_id.toString() === PRICE_UNIT_VARIANT_ID) {
              // Create a key for this cart item
              const itemPropertyKeys = Object.keys(item.properties || {}).filter(key => !key.startsWith('_'));
              const itemPropertyKey = itemPropertyKeys.map(key => `${key}:${item.properties[key]}`).sort().join('|');
              
              console.log("Existing item property key:", itemPropertyKey);
              
              // Compare keys ignoring whitespace and case
              const normalizedNewKey = propertyKey.replace(/\s+/g, '').toLowerCase();
              const normalizedItemKey = itemPropertyKey.replace(/\s+/g, '').toLowerCase();
              
              if (normalizedItemKey === normalizedNewKey) {
                console.log("Found identical item!");
                identicalItem = item;
                identicalItemIndex = index + 1; // Shopify uses 1-based indexing for line items
              }
            }
          });
          
          if (identicalItem) {
            // Found an identical item, update its quantity
            const existingQuantity = parseInt(identicalItem.properties._Quantity || 1);
            const newQuantity = existingQuantity + userQuantity;
            const newProperties = {...properties, _Quantity: newQuantity.toString()};
            
            // Calculate the new price quantity
            const newPriceQuantity = Math.round(itemPrice * 100) * newQuantity;
            
            // Update the cart item
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: identicalItemIndex,
                quantity: newPriceQuantity,
                properties: newProperties
              })
            });
          } else {
            // No identical item, add a new one
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: PRICE_UNIT_VARIANT_ID,
                quantity: quantityForCart,
                properties: properties
              })
            });
          }
        })
        .then(response => response.json())
        .then(result => {
          if (result.status >= 400) {
            throw new Error(result.description);
          }
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Error:', error);
          addToCartText.textContent = 'Error!';
          setTimeout(() => {
            addToCartText.textContent = 'Add to Cart';
            customAddToCartButton.disabled = false;
          }, 2000);
        });
    };

    // If a file is present, do multipart upload path
    const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;

    // Enforce requirement for arched/half-arch: must have file OR template checkbox
    if ((shapeSelect.value === 'arched' || shapeSelect.value === 'half-arch') && !hasFile) {
      const hasTemplateTick = !!calculator.querySelector('input[name="properties[Will Send Template]"]:checked');
      if (!hasTemplateTick) {
        alert('For arched or half-arch shapes, please upload a drawing or tick the template checkbox.');
        return;
      }
    }

    if (hasFile && simplePool) {
      try {
        addToCartText.textContent = 'Preparing...';
        customAddToCartButton.disabled = true;

        // 1) Find a pool variant
        const variantId = await simplePool.findAvailableVariant();

        // 2) Generate title and sku the same way pool does
        const title = simplePool.generateTitle({
          productType: 'glass',
          shape: shapeSelect.value,
          width: parseFloat(widthInput.value) || 0,
          height: parseFloat(heightInput.value) || 0,
          diameter: parseFloat(diameterInput.value) || 0,
          thickness: thicknessSelect.value,
          units: unitSelect.value
        });
        const sku = simplePool.generateSKU({
          productType: 'glass',
          shape: shapeSelect.value,
          width: parseFloat(widthInput.value) || 0,
          height: parseFloat(heightInput.value) || 0,
          inputC: parseFloat(inputC.value) || 0,
          inputD: parseFloat(inputD.value) || 0,
          diameter: parseFloat(diameterInput.value) || 0,
          thickness: thicknessSelect.value,
          units: unitSelect.value,
          ropeKit: { selected: ropeSelect && ropeSelect.value && ropeSelect.value !== 'none' },
          gasket: { selected: tapeSelect && tapeSelect.value && tapeSelect.value !== 'none' }
        });

        // 3) Update variant
        await simplePool.updateVariantDetails(variantId, {
          title: title,
          price: itemPrice,
          sku: sku
        });

        // 4) Build multipart form and submit to /cart/add
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/cart/add';
        form.enctype = 'multipart/form-data';
        form.style.display = 'none';

        const idInputHidden = document.createElement('input');
        idInputHidden.type = 'hidden';
        idInputHidden.name = 'id';
        idInputHidden.value = variantId;
        form.appendChild(idInputHidden);

        // price-unit quantity style (keep your existing behavior)
        const quantityForCart = Math.round(itemPrice * 100) * (parseInt(quantityInput.value) || 1);
        const qtyHidden = document.createElement('input');
        qtyHidden.type = 'hidden';
        qtyHidden.name = 'quantity';
        qtyHidden.value = String(quantityForCart);
        form.appendChild(qtyHidden);

        // Append all properties
        Object.keys(properties).forEach(key => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = properties[key];
          form.appendChild(input);
        });

        // Move the file input into the form so Shopify uploads it
        form.appendChild(fileInput);

        document.body.appendChild(form);
        form.submit();
        return; // end handler
      } catch (err) {
        console.error('Multipart path failed, falling back to pool:', err);
        // continue to simple pool normal path below
      }
    }

    // Add multipart fallback when pool fails but file is present
    const multipartFallback = () => {
      if (hasFile) {
        try {
          console.log('Using multipart fallback with PRICE_UNIT_VARIANT_ID...');
          
          // Build multipart form with fallback variant ID
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = '/cart/add';
          form.enctype = 'multipart/form-data';
          form.style.display = 'none';

          const idInputHidden = document.createElement('input');
          idInputHidden.type = 'hidden';
          idInputHidden.name = 'id';
          idInputHidden.value = PRICE_UNIT_VARIANT_ID;
          form.appendChild(idInputHidden);

          // price-unit quantity style
          const quantityForCart = Math.round(itemPrice * 100) * userQuantity;
          const qtyHidden = document.createElement('input');
          qtyHidden.type = 'hidden';
          qtyHidden.name = 'quantity';
          qtyHidden.value = String(quantityForCart);
          form.appendChild(qtyHidden);

          // Append all properties
          Object.keys(properties).forEach(key => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.value = properties[key];
            form.appendChild(input);
          });

          // Move the file input into the form so Shopify uploads it
          form.appendChild(fileInput);

          document.body.appendChild(form);
          form.submit();
          return true; // Indicate success
        } catch (fallbackErr) {
          console.error('Multipart fallback also failed:', fallbackErr);
          return false; // Indicate failure
        }
      }
      return false; // No file, can't use multipart
    };

    // Try simple variant pool first, then draft orders, then fallback to original
    if (simplePool) {
      console.log('Using simple variant pool method...');

      // Build accessory selections for SKU generation
      let ropeKit = { selected: false };
      if (ropeSelect && ropeSelect.value && ropeSelect.value !== 'none') {
        const parts = ropeSelect.value.split('-'); // e.g., "10mm-white"
        const diaStr = parts[0] || '';
        const color = parts[1] || '';
        const diameterMm = parseInt(diaStr.replace(/[^0-9]/g, ''), 10);
        
        console.log('Rope selection debug:', {
          value: ropeSelect.value,
          parts: parts,
          diaStr: diaStr,
          color: color,
          diameterMm: diameterMm
        });
        
        ropeKit = {
          selected: true,
          diameterMm: isNaN(diameterMm) ? undefined : diameterMm,
          color: color
        };
      }

      const gasket = {
        selected: !!(tapeSelect && tapeSelect.value && tapeSelect.value !== 'none'),
        color: (tapeSelect && tapeSelect.value && tapeSelect.value !== 'none') ? tapeSelect.value : undefined,
        lengthMeters: 2 // default length for supplier reference
      };

      console.log('Final ropeKit object being passed to processOrder:', ropeKit);
      console.log('Final gasket object being passed to processOrder:', gasket);
      
      // Step 0: Verify variant is clean (non-blocking monitoring)
      console.log('🔍 Using variant:', PRICE_UNIT_VARIANT_ID, 'for order:', properties);
      
      // Run validation in background without blocking the main flow
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const variantInUse = cart.items.some(item => item.variant_id.toString() === PRICE_UNIT_VARIANT_ID);
          if (variantInUse) {
            console.warn('⚠️ Variant already in use, this could cause issues');
          }
        })
        .catch(error => console.log('Cart verification failed:', error));
      
      // Update button messaging to match brick calculator
      addToCartText.textContent = 'Creating Your Order...';
      
      simplePool.processOrder({
        itemPrice: itemPrice,
        quantity: userQuantity,
        properties: properties,
        shape: shapeSelect.value,
        width: parseFloat(widthInput.value) || 0,
        height: parseFloat(heightInput.value) || 0,
        inputC: parseFloat(inputC.value) || 0,
        inputD: parseFloat(inputD.value) || 0,
        diameter: parseFloat(diameterInput.value) || 0,
        thickness: thicknessSelect.value,
        units: unitSelect.value,
        ropeKit: ropeKit,
        gasket: gasket
      }, () => {
        // If simple pool fails, try multipart fallback first (for file uploads)
        if (multipartFallback()) {
          return; // Successfully used multipart fallback
        }
        
        // If multipart fallback not applicable or failed, try draft orders
        if (draftOrderHandler) {
          console.log('Simple pool failed, trying draft orders...');
          addToCartText.textContent = 'Using Backup Method...';
          draftOrderHandler.processCalculatorOrder({
            itemPrice: itemPrice,
            quantity: userQuantity,
            properties: properties,
            fallbackFunction: fallbackToOriginalCart
          });
        } else {
          // No draft orders available, use original cart method
          console.log('No draft orders available, using original cart method');
          addToCartText.textContent = 'Using Fallback...';
          fallbackToOriginalCart();
        }
      });
    } else if (draftOrderHandler) {
      console.log('Simple pool not available, using draft orders...');
      draftOrderHandler.processCalculatorOrder({
        itemPrice: itemPrice,
        quantity: userQuantity,
        properties: properties,
        fallbackFunction: () => {
          // Try multipart fallback first if file is present
          if (multipartFallback()) {
            return; // Successfully used multipart fallback
          }
          // Otherwise use original cart method
          fallbackToOriginalCart();
        }
      });
    } else {
      // No advanced methods available, use original method
      console.log('No advanced methods available, using original cart method');
      addToCartText.textContent = 'Adding...';
      customAddToCartButton.disabled = true;
      fallbackToOriginalCart();
    }
  });

  // --- File Upload to Shopify Function ---
  async function uploadFileToShopify(file) {
    try {
      // Generate a unique reference ID
      const timestamp = Date.now();
      const randomString = Math.random().toString(36).substring(2, 8);
      const fileId = `DRAW-${timestamp.toString(36).toUpperCase()}-${randomString.toUpperCase()}`;
      
      // For files smaller than 5MB, we can include them as base64 in the order
      if (file.size <= 5 * 1024 * 1024) {
        try {
          const dataUrl = await fileToDataURL(file);
          
          // Check if the base64 data will fit in Shopify's property limits
          const base64Data = dataUrl.split(',')[1];
          const propertyValue = `data:${file.type};name=${encodeURIComponent(file.name)};size=${file.size};id=${fileId},${base64Data}`;
          
          // Shopify line item properties have a 5000 character limit total
          // If too large for properties, we'll store in cart notes or use email
          if (propertyValue.length > 4000) {
            // Try to store in cart notes as backup
            const cartNoteData = {
              type: 'file_upload',
              id: fileId,
              name: file.name,
              size: file.size,
              fileType: file.type,
              data: base64Data,
              timestamp: timestamp
            };
            
            // Store in sessionStorage for cart notes
            sessionStorage.setItem(`cart_file_${fileId}`, JSON.stringify(cartNoteData));
            
            // Return a reference that will be added to cart notes
            return `CART_FILE:${fileId}:${file.name}:${file.size}`;
          } else {
            // Store the complete file data for the order properties
            const fileData = {
              id: fileId,
              name: file.name,
              size: file.size,
              type: file.type,
              data: dataUrl,
              timestamp: timestamp
            };
            
            // Store in sessionStorage for the checkout process
            sessionStorage.setItem(`upload_${fileId}`, JSON.stringify(fileData));
            
            // Return a URL that includes the file data
            return propertyValue;
          }
          
        } catch (error) {
          console.error('Base64 conversion error:', error);
          throw error;
        }
      } else {
        // For larger files (>5MB), automatically email them
        try {
          const emailSent = await sendFileViaEmail(file, fileId);
          
          if (emailSent) {
            // File was automatically emailed
            return `AUTO_EMAILED:${fileId}:${file.name}:${file.size}:SENT`;
          } else {
            // Fallback to manual email instructions
            const fileInfo = {
              id: fileId,
              name: file.name,
              size: file.size,
              type: file.type,
              timestamp: timestamp,
              instructions: `Please email this file to stoveglassreplacement@gmail.com with reference: ${fileId}`
            };
            
            // Store reference info
            sessionStorage.setItem(`upload_${fileId}`, JSON.stringify(fileInfo));
            
            // Return reference URL for manual email
            return `mailto:stoveglassreplacement@gmail.com?subject=Drawing Upload - Reference ${fileId}&body=Please find attached the drawing file: ${file.name} (${(file.size / 1024 / 1024).toFixed(1)}MB)`;
          }
        } catch (emailError) {
          console.error('Email sending failed:', emailError);
          
          // Fallback to manual email instructions
          const fileInfo = {
            id: fileId,
            name: file.name,
            size: file.size,
            type: file.type,
            timestamp: timestamp,
            instructions: `Please email this file to stoveglassreplacement@gmail.com with reference: ${fileId}`
          };
          
          sessionStorage.setItem(`upload_${fileId}`, JSON.stringify(fileInfo));
          return `mailto:stoveglassreplacement@gmail.com?subject=Drawing Upload - Reference ${fileId}&body=Please find attached the drawing file: ${file.name} (${(file.size / 1024 / 1024).toFixed(1)}MB)`;
        }
      }
      
    } catch (error) {
      console.error('Upload processing error:', error);
      throw new Error('Failed to process file upload');
    }
  }

  // --- Automatic Email Function ---
  async function sendFileViaEmail(file, fileId) {
    try {
      // Convert file to base64 for email attachment
      const base64Data = await fileToDataURL(file);
      
      // Create email data
      const emailData = {
        to: 'stoveglassreplacement@gmail.com',
        subject: `Drawing Upload - Reference ${fileId}`,
        body: `
          Automatic file upload from custom calculator:
          
          Reference: ${fileId}
          File Name: ${file.name}
          File Size: ${(file.size / 1024 / 1024).toFixed(2)}MB
          File Type: ${file.type}
          Upload Time: ${new Date().toISOString()}
          
          The file is attached as base64 data below:
          ${base64Data}
        `
      };
      
      // Try to send via a webhook or email service
      // Note: This would require a backend service to actually send emails
      // For now, we'll simulate the email and return false to use manual method
      
      console.log('Email data prepared:', {
        reference: fileId,
        fileName: file.name,
        fileSize: file.size,
        dataLength: base64Data.length
      });
      
      // In a real implementation, you would send this to your email service
      // return await fetch('/send-email', { method: 'POST', body: JSON.stringify(emailData) });
      
      // For now, return false to use manual email method
      return false;
      
    } catch (error) {
      console.error('Email preparation error:', error);
      return false;
    }
  }

  // Helper function to convert file to data URL
  function fileToDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  // --- File Upload Functionality ---
  if (uploadButton && fileInput) {
    uploadButton.addEventListener('click', () => {
      fileInput.click();
    });

    fileInput.addEventListener('change', async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      // Validate file size (max 50MB total)
      if (file.size > 50 * 1024 * 1024) {
        uploadStatus.textContent = 'File too large. Maximum size is 50MB.';
        uploadStatus.style.color = 'red';
        return;
      }
      
      // Show info for different file sizes
      if (file.size > 5 * 1024 * 1024) {
        uploadStatus.innerHTML = `
          <div style="color: #ff9800; margin-bottom: 8px;">⚠ Large file detected</div>
          <div style="color: #666; font-size: 12px;">
            Files over 5MB will be automatically emailed to our team. Processing...
          </div>
        `;
      } else if (file.size > 1024 * 1024) {
        uploadStatus.innerHTML = `
          <div style="color: #2196f3; margin-bottom: 8px;">📁 Medium file detected</div>
          <div style="color: #666; font-size: 12px;">
            Processing file for direct attachment...
          </div>
        `;
      }

      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        uploadStatus.textContent = 'Invalid file type. Please upload an image (JPG, PNG, GIF, WebP) or PDF file.';
        uploadStatus.style.color = 'red';
        return;
      }

      // Show uploading status
      uploadText.textContent = 'Uploading...';
      uploadButton.disabled = true;
      uploadStatus.textContent = 'Uploading file to Shopify...';
      uploadStatus.style.color = '#666';

      // Just show "file selected" UI - let multipart /cart/add handle the actual upload
      handleFileSelected(file.name);
      
      // Update calculator to hide template checkbox since file is selected
      updateCalculator();
    });

    function handleFileSelected(name) {
      uploadStatus.innerHTML = `
        <div style="color: #28a745; margin-bottom: 8px;">✓ File selected!</div>
        <div style="color: #666; font-size: 12px;">
          File will be uploaded when you add to cart.
        </div>
      `;
      uploadText.textContent = 'File Selected';
      uploadButton.disabled = false;
      
      // Show file info
      fileName.textContent = name;
      uploadedFileInfo.style.display = 'flex';
      uploadedFileUrl.value = ''; // Let Shopify generate the URL on submit
      
      // Hide upload button
      uploadButton.style.display = 'none';
    }

    function handleUploadSuccess(name, url) {
      uploadStatus.innerHTML = `
        <div style="color: #28a745; margin-bottom: 8px;">✓ File uploaded successfully!</div>
        <div style="color: #666; font-size: 12px;">
          File will be attached to your order and accessible to our team.
        </div>
      `;
      uploadText.textContent = 'File Uploaded';
      uploadButton.disabled = false;
      
      // Show file info
      fileName.textContent = name;
      uploadedFileInfo.style.display = 'flex';
      uploadedFileUrl.value = url;
      
      // Hide upload button
      uploadButton.style.display = 'none';
      
      // Update calculator to hide template checkbox since file is uploaded
      updateCalculator();
    }

    if (removeFileButton) {
      removeFileButton.addEventListener('click', () => {
        // Reset file upload
        fileInput.value = '';
        uploadedFileUrl.value = '';
        uploadedFileInfo.style.display = 'none';
        uploadButton.style.display = 'inline-block';
        uploadText.textContent = 'Choose File';
        uploadStatus.textContent = '';
        uploadButton.disabled = false;
      });
    }
  }

  // --- Attach Event Listeners ---
  allInputs.forEach(element => {
    element.addEventListener('input', updateCalculator);
    element.addEventListener('change', updateCalculator);
  });
  
  // Add specific listener for shape changes
  if (shapeSelect) {
    shapeSelect.addEventListener('change', function() {
      debugLog('Shape selector changed to:', this.value);
      updateCalculator(); // Call full update, not just preview
    });
  }
  
  // Add specific listener for unit changes
  if (unitSelect) {
    const inchHelperText = document.getElementById('inch-helper-text');
    
    unitSelect.addEventListener('change', function() {
      // Show/hide inch helper text
      if (inchHelperText) {
        inchHelperText.style.display = this.value === 'in' ? 'block' : 'none';
      }
      
      updateCalculator();
    });
    
    // Initialize helper text visibility
    if (inchHelperText) {
      inchHelperText.style.display = unitSelect.value === 'in' ? 'block' : 'none';
    }
  }

  // --- Initial State ---
  // Hide all dimension rows initially to prevent flash
  Object.values(dimensionRows).forEach(row => {
    if (row) {
      row.style.display = 'none';
    }
  });
  
  updateCalculator();
});